export default {
    
    clone_settings_modal_title: "Clonar la configuración",
    clone_settings_modal_message: "La configuración seleccionada va a sobre escribir la configuración de los dispositivos seleccionados, ¿Desea continuar?",
    clone_settings_modal_close: "Cancelar",
    clone_settings_modal_save: "Guardar",
    
};